import { buildInitialStatusForm } from './StatusTab/utils';
import { buildInitialScheduleForm } from './ScheduleTab/utils';

export const toMapById = (array, key) => (
  Object.fromEntries(array?.map(item => [item[key], item]) || [])
);

export const createInitialModalState = (equipment, checkboxValue) => {
  const statusForm = buildInitialStatusForm(equipment, checkboxValue);
  const scheduleForm = buildInitialScheduleForm(equipment);

  return {
    status: {
      form: statusForm,
      originalForm: statusForm,
      dateError: null,
      isConfirmChangesStep: false,
      checkboxValue,
    },
    schedule: {
      form: scheduleForm,
      originalForm: scheduleForm,
      dateError: null,
    },
  };
};

export const resetModalState = () => ({
  status: {
    form: {},
    originalForm: {},
    dateError: null,
    isConfirmChangesStep: false,
    checkboxValue: 0,
  },
  schedule: {
    form: {},
    originalForm: {},
    dateError: null,
  },
});
